<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="700"
  >
    <a-form
      :model="formState"
      :rules="rules"
      ref="formRef"
      :label-col="{ style: { width: '80px' } }"
      :wrapper-col="{ style: { width: '220px' } }"
      layout="inline"
    >
      <a-form-item label="问题" name="problem">
        <a-textarea
          v-model:value="formState.problem"
          placeholder="请输入问题"
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="问题类型" name="questionType">
        <!-- <a-input
          v-model:value="formState.questionType"
          placeholder="请输入问题类型"
          allowClear
        ></a-input> -->
        <a-select
          v-model:value="formState.questionType"
          :options="questionTypeOption"
          placeholder="请选择问题类型"
          allowClear
        >
        </a-select>
      </a-form-item>
      <a-form-item label="状态" name="status">
        <a-select v-model:value="formState.status" placeholder="请选择状态">
          <a-select-option value="整改完毕">整改完毕</a-select-option>
          <a-select-option value="未完成">未完成</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="频次" name="frequency">
        <a-input-number
          style="width: 220px"
          v-model:value="formState.frequency"
          placeholder="请输入频次"
          allowClear
        >
        </a-input-number>
      </a-form-item>
      <a-form-item label="部件名称" name="componentName">
        <a-input
          v-model:value="formState.componentName"
          placeholder="请输入部件名称"
        ></a-input>
      </a-form-item>

      <a-form-item label="部件编码" name="componentCode">
        <a-input
          v-model:value="formState.componentCode"
          placeholder="请输入部件编码"
        ></a-input>
      </a-form-item>
      <a-form-item label="原因" name="reason">
        <a-textarea
          v-model:value="formState.reason"
          placeholder="请输入原因"
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="处理类型" name="processType">
        <a-select
          v-model:value="formState.processType"
          placeholder="请选择处理类型"
        >
          <a-select-option value="单点解决">单点解决</a-select-option>
          <a-select-option value="工序停产整改">工序停产整改</a-select-option>
          <a-select-option value="截流停产整改">截流停产整改</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="处理措施" name="handlingMeasures">
        <a-textarea
          v-model:value="formState.handlingMeasures"
          placeholder="请输入处理措施"
          auto-size
        ></a-textarea>
      </a-form-item>

      <a-form-item label="时间" name="localDate">
        <a-date-picker
          v-model:value="formState.localDate"
          placeholder="请选择问题发生时间"
          allowClear
        >
        </a-date-picker>
      </a-form-item>

      <a-form-item label="主管确认" name="supervisorConfirmation">
        <a-select
          v-model:value="formState.supervisorConfirmation"
          placeholder="主管是否确认问题"
          allowClear
        >
          <a-select-option :value="0">待确认</a-select-option>
          <a-select-option :value="1">已确认</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="图片">
        <upload-img-vue
          ref="imgRef"
          :attachment="formState.picture"
          :requestFn="uploadProduceAttachment"
        ></upload-img-vue>
      </a-form-item>
      <a-form-item label="视频">
        <upload-video-vue
          ref="videoRef"
          :attachment="formState.video"
          :requestFn="uploadProduceAttachment"
        ></upload-video-vue>
      </a-form-item>

      <a-form-item label="备注" style="width: 600px">
        <content-dsc-vue :question="formState.notes" ref="notesRef">
        </content-dsc-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, inject, reactive, ref } from "vue";
import { useStore } from "vuex";
import { showUploading, hideUploading } from "@/utils/index";
import {
  saveOrUpdateAbnormalProblemHandle,
  uploadProduceAttachment,
} from "@/request/view/product";
import {
  modelSpecificationsOption,
  questionTypeOption,
} from "@/views/productDaily/serve/option";
import contentDscVue from "@/views/productDaily/components/quality/components/question.vue";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";

export default defineComponent({
  props: {
    type: String,
    produceOrTpc: String,
  },
  components: { uploadImgVue, uploadVideoVue, contentDscVue },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });
    const imgRef = ref();
    const videoRef = ref();
    const notesRef = ref();
    const formState = reactive({
      type: null,
      frequency: null,
      questionType: null,
      supervisorConfirmation: null,
      localDate: timeStampToTime("", "upload"),
      id: null,
      componentName: null,
      componentCode: null,
      notes: null,
      produceOrTpc: null,
      handlingMeasures: null,
      localDate: null,
      status: null,
      picture: null,
      problem: null,
      video: null,
      processType: null,
      project: null,
      reason: null,
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加质检数据") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {
      problem: [
        {
          required: true,
          message: "请输入问题",
          trigger: "change",
          type: "string",
        },
      ],

      // componentName: [
      //   {
      //     required: true,
      //     message: "请输入部件名称/编码",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // reason: [
      //   {
      //     required: true,
      //     message: "请输入原因",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // handlingMeasures: [
      //   {
      //     required: true,
      //     message: "请输入处理措施",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      questionType: [
        {
          required: true,
          message: "请选择问题类型",
          trigger: "change",
          type: "string",
        },
      ],
      frequency: [
        {
          required: true,
          message: "请输入频次",
          trigger: "change",
          type: "number",
        },
      ],
      project: [
        {
          required: true,
          message: "请选择项目",
          trigger: "change",
          type: "string",
        },
      ],
      status: [
        {
          required: true,
          message: "请选择状态",
          trigger: "change",
          type: "string",
        },
      ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addProblem") {
        modalConfig.title = "添加异常问题统计";
        formState.localDate = timeStampToTime("", "upload");
        const { id, username } = store.state.user.user;
        formState.userId = id;
        formState.username = username;
        formState.type = props.type;
        formState.project = "swan";
        formState.produceOrTpc = props.produceOrTpc;
      } else if (type === "editProblem") {
        modalConfig.title = "编辑异常问题统计";
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            await imgRef.value
              .uploadFile(showUploading)
              .then((res) => {
                formState.picture = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await videoRef.value
              .uploadFile(showUploading)
              .then((res) => {
                formState.video = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });
            await notesRef.value
              .uploadFile(showUploading)
              .then((res) => {
                formState.notes = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await saveOrUpdateAbnormalProblemHandle(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
                hideUploading();
              })
              .catch((err) => {
                console.log(err);
                hideUploading();
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      notesRef,
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      questionTypeOption,
      formState,
      rules,
      isEdit,
      imgRef,
      videoRef,
      modelSpecificationsOption,
      uploadProduceAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 10px;
}
</style>
